import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorIcon from "@mui/icons-material/Error";
import { Tooltip } from "@mui/material";
export const ServingAmountLimitedAccessWarning = ({ serving }) => {
    return (_jsx(Tooltip, { title: _jsxs(_Fragment, { children: [getLimitedAccessTooltipText(serving.foodOrRecipe), serving.foodOrRecipe.__typename === "Recipe" && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("br", {}), `Created by ${serving.foodOrRecipe.createdBy.firstName} ${serving.foodOrRecipe.createdBy.lastName}`] }))] }), children: _jsx(ErrorIcon, { fontSize: "small", color: "primary" }) }));
};
const getLimitedAccessTooltipText = (foodOrRecipe) => {
    const orgText = foodOrRecipe.org ? ` (${foodOrRecipe.org.name})` : " ";
    if (foodOrRecipe.__typename === "Recipe") {
        return `This recipe is part of another organization${orgText} and will not be added to your organization’s recipes. You and your athletes can only view the recipe name and its nutrients.`;
    }
    else {
        return `This custom food is part of another organization${orgText} and will not be added to your organization’s foods. You and your athletes can only view the food name and its nutrients.`;
    }
};
//# sourceMappingURL=LimitedAccessWarning.js.map